import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Fold = styled(Flex).attrs({
  width: '100%',
  column: true,
})`
  padding: 10px 0;
  border-top: 1px solid #E7EDF2;

  &:last-of-type {
    border-bottom: 1px solid #E7EDF2;
  }
`;

export const Title = styled(Flex).attrs({
  width: '100%',
  align: 'center',
})`
  color: ${props => (props.active ? props.theme.colors.primary : '#121827')};
  cursor: pointer;
  user-select: none;

  i {
    margin-right: 10px;
  }

  span {
    margin-right: 3px;
  }
`;
